export enum EcommerceOrderStatus {
	CONFIRMED = "confirmed",
	FORWARDED = "forwarded"
}
